<mat-toolbar class="flyout-toolbar">
    <span class="flyout-toolbar-full-title">{{flyoutTitle}}</span>
    <span class="flyout-toolbar-spacer"></span>
    <mat-icon class="flyout-toolbar-icon"
        *ngIf="!preventClosing"
        mat-button (click)="flyoutClosed.emit()"
        matTooltip="Close">close</mat-icon>
</mat-toolbar>